import {createFileRoute} from '@tanstack/react-router';
import {practitionerAdminGranted, grantUser} from '@/practitioner/routing/utils/beforeLoadUtils';

import PaymentOrderList from '@/practitioner/views/payments/PaymentOrderList';

export const Route = createFileRoute('/(practitioner)/practitioner/patient-payment-orders')({
  component: PaymentOrderList,
  beforeLoad: grantUser(practitionerAdminGranted)
});
